// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_GROUPS = "Skupiny";
export const TAB_FORUMS = "Diskusie";
export const TAB_GROUPS = "Skupiny";
